/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, makeStyles } from '@material-ui/core';
import { func, string } from 'prop-types';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = makeStyles({
    container: ({ brandColor }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: '414px',
        borderBottom: '3px solid #F5F5F5',
        '@media screen and (min-width: 768px)': {
            justifyContent: 'inherit',
            maxWidth: '100%',
        },
        '& ._button': {
            backgroundColor: 'transparent',
            fontSize: '16px',
            lineHeight: '24px',
            padding: '9px 30px',
            letterSpacing: '0.01em',
            textAlign: 'center',
            borderRadius: '0px',
            boxShadow: 'none',
            margin: '0 16px -3px 0',
            textTransform: 'capitalize',
            borderBottom: '3px solid transparent',
            '&:hover': {
                background: '#F5F5F5',
                borderBottom: '3px solid #D9D9D9',
            },
        },
        '& ._selected_btn': {
            color: brandColor || '#201648',
            borderBottom: `3px solid ${brandColor || '#201648'}`,
            fontWeight: 'bold',
            '&:hover': {
                background: 'transparent !important',
                borderBottom: `3px solid ${brandColor || '#201648'} !important`,
            },
        },
    }),
});

const StatusBar = ({ handleFilter, activeFilter, brandColor }) => {
    const dispatch = useDispatch();
    const classes = styles({ brandColor });

    const trackHandler = (eventLabel) => {
        handleFilter(eventLabel);
        dispatch(trackEvent({
            eventCategory: 'Subscriptions Management Portal',
            eventAction: 'click',
            eventLabel: `${eventLabel} - view`,
        }));
    };

    return (
        <div className={classes.container}>
            <Button
                className={`_button ${activeFilter === 'ACTIVE' ? '_selected_btn' : ''}`}
                align="center"
                onClick={() => trackHandler('ACTIVE')}
            >
                Active
            </Button>
            <Button
                className={`_button ${activeFilter === 'PAUSED' ? '_selected_btn' : ''}`}
                align="center"
                onClick={() => trackHandler('PAUSED')}
            >
                Paused
            </Button>
            <Button
                className={`_button ${activeFilter === 'CANCELLED' ? '_selected_btn' : ''}`}
                align="center"
                onClick={() => trackHandler('CANCELLED')}
            >
                Cancelled
            </Button>
        </div>
    );
};

StatusBar.propTypes = {
    brandColor: string.isRequired,
    handleFilter: func.isRequired,
    activeFilter: string.isRequired,
};

export default StatusBar;
